import Input, { type InputProps } from './Input';

export type { InputProps };
export default Input;
